export default "__VITE_ASSET__Br1Zu9ni__"